/*
 *  Collection Template
 *    Contains all the scripts used for the collection template.
 *
 *  Version:
 *    1.0.0 - 2023/06/05
 */



import { initialiseProductThumbnails } from '../../objects/product/product-thumbnail';
import { Section } from '../../tools/section';

// Selectors
const SELECTOR_COLLECTION_TEMPLATE = '[data-collection-template]';

class CollectionTemplate extends Section  {
  queryChildren(container: HTMLElement): void {
    
  }

  attachEvents(): void {
    initialiseProductThumbnails();
  }

  detatchEvents(): void {
    
  }
}

Section.register(SELECTOR_COLLECTION_TEMPLATE, CollectionTemplate);